import React from "react";
import Header from "../../header";
import TopActionsComponent from "../../top-actions-component";
import PurchaseRequisitionAddModal from "./paper-add-modal";
import PurchaseRequisitionEditModal from "./paper-edit-modal";
import { Constants } from "../../../constants";
import RedirectIfNotLogged from "../../menu/redirect-if-not-logged";
import {
  CircularProgress,
  DropDownMenu,
  FlatButton,
  MenuItem,
  TextField,
} from "material-ui";
import TablePaper from "./paper-table";
import { connect } from "react-redux";
import * as RequisitionTypes from "../../../general/paper-state";
import request from "../../../config/axios-config";
import * as ErrorAction from "../../../redux/action/error-action";
import * as validator from "../../../general/validators/validator";
import { Pagination } from "react-bootstrap";
import { HorizontalContainer, VerticalContainer } from "../../Common";
import { PrintComponent } from "../../print/PrintComponent";
import { PrintDialog } from "../../print/PrintDialog";

let fileSaver = require("file-saver");

const FILTER_ALL = 0;
const FILTER_APROVED = 1;
const FILTER_IN_PROGRESS = 2;
const FILTER_REJECTED = 3;
const FILTER_BY_ME = 4;
const FILTER_DRAFT = 5;

const SEARCH_PAPER = 0;
const SEARCH_FINANCE_SOURCE = 1;
const SEARCH_DEPARTMENT = 2;
const SEARCH_ACQUISITION_CATEGORY = 3;
const SEARCH_BY_DATE = 4;
const SEARCH_ENGINE = 5;

const SEARCH_HINT_SEARCH_ENGINE = 'De exemplu "Romeo și Julieta"';
const SEARCH_HINT_PAPER = 'De exemplu "1/2017"';
const SEARCH_HINT_FINANCE_SOURCE = 'De exemplu "buget de stat"';
const SEARCH_HINT_DEPARTMENT = 'De exemplu "conducere"';
const SEARCH_HINT_ACQUISITION_CATEHORY = 'De exemplu "produse"';
const SEARCH_HINT_BY_DATE = 'De exemplu "1/12/2017"';

class PaperPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      wasDataLoaded: false,
      showPrintDialog: false,
      printPaper: null,
      lastPage: true,
      showAdd: false,
      showEdit: false,
      forceLogin: false,
      editData: {},
      loadingData: false,
      page: 0,
      activePage: 1,
      emptyData: false,
      filterValue: FILTER_ALL,
      searchValue: SEARCH_ENGINE,
      searchWords: "",
      searchHintText: SEARCH_HINT_SEARCH_ENGINE,
      totalPages: 0,
      downloadingDoc: false,
      downloadingReport: false,
      reportYear: new Date().getFullYear(),
    };
  }

  componentDidMount() {
    this.props.hideError();
    this.refreshData(this.props.match.params.page);
  }

  componentWillUnmount() {
    this.props.hideError();
    this.setState({ wasDataLoaded: false });
  }

  onFilterChanged = (event, index, value) => {
    this.setState({ filterValue: value, searchWords: "", page: 0 }, () => {
      this.props.history.push("/app/referate/0");
      this.refreshData(0);
    });
  };

  onSearchChanged = (event, index, value) => {
    let hintText = "";
    let searchValue = value;

    if (searchValue === SEARCH_PAPER) {
      hintText = SEARCH_HINT_PAPER;
    } else if (searchValue === SEARCH_FINANCE_SOURCE) {
      hintText = SEARCH_HINT_FINANCE_SOURCE;
    } else if (searchValue === SEARCH_DEPARTMENT) {
      hintText = SEARCH_HINT_DEPARTMENT;
    } else if (searchValue === SEARCH_ACQUISITION_CATEGORY) {
      hintText = SEARCH_HINT_ACQUISITION_CATEHORY;
    } else if (searchValue === SEARCH_BY_DATE) {
      hintText = SEARCH_HINT_BY_DATE;
    } else if (searchValue === SEARCH_ENGINE) {
      hintText = SEARCH_HINT_SEARCH_ENGINE;
    }

    this.setState({
      searchHintText: hintText,
      searchWords: "",
      searchValue: value,
      filterValue: FILTER_ALL,
    });
  };

  refreshData = (page) => {
    this.props.hideError();
    this.setState({ loadingData: true });
    if (page === undefined || page === null) {
      page = 0;
    }
    let searchQuery = this.getSearchQeury();
    let filterQuery = this.getFilterQuery();

    this.props
      .getData(page, this.state.searchWords ? searchQuery : filterQuery)
      .then((response) => {
        let isEmptyData =
          !response.data.content || response.data.content.length === 0;
        this.setState({
          data: response.data.content,
          lastPage: response.data.last,
          loadingData: false,
          emptyData: isEmptyData,
          totalPages: response.data.totalPages,
        });
      })
      .catch((err) => {
        this.props.showError("A aparut o eroare. Va rog reincercati!");
        this.setState({ loadingData: false });
      });
  };

  getFilterQuery = () => {
    let query = "?filter=";
    let filter = this.state.filterValue;
    if (filter === FILTER_ALL) {
      return query + "all";
    } else if (filter === FILTER_BY_ME) {
      return query + "mine";
    } else if (filter === FILTER_REJECTED) {
      return query + "rejected";
    } else if (filter === FILTER_IN_PROGRESS) {
      return query + "progress";
    } else if (filter === FILTER_APROVED) {
      return query + "approved";
    } else if (filter === FILTER_DRAFT) {
      return query + "draft";
    }
    return query + "all";
  };

  getSearchQeury = () => {
    let query = "?search=";
    let searchValue = this.state.searchValue;

    if (searchValue === SEARCH_PAPER) {
      query += "search_paper";
    } else if (searchValue === SEARCH_FINANCE_SOURCE) {
      query += "search_finance_source";
    } else if (searchValue === SEARCH_DEPARTMENT) {
      query += "search_department";
    } else if (searchValue === SEARCH_ACQUISITION_CATEGORY) {
      query += "search_acquisition_category";
    } else if (searchValue === SEARCH_BY_DATE) {
      query += "search_by_date";
    } else if (searchValue === SEARCH_ENGINE) {
      query += "search_engine";
    }

    if (validator.isEmpty(this.state.searchWords)) {
      return null;
    }
    return query + "&p=" + this.state.searchWords;
  };

  onAddClicked = (forNextYear) => {
    this.setState({ showAdd: true, addData: null, forNextYear: forNextYear });
    this.props.onDialogVisible(true);
  };

  onEditClicked = (el) => {
    if (RequisitionTypes.isDraft(el.state)) {
      this.setState({ addData: el, showAdd: true });
    } else {
      this.setState({ editData: el, showEdit: true });
    }

    this.props.onDialogVisible(true);
  };

  onDeleteClicked = (paper) => {
    if (RequisitionTypes.isDraft(paper.state)) {
      request({
        url: "/paper/delete/draft/" + paper.id,
        method: "post",
      })
        .then((t) => {
          let index = this.state.data.indexOf(paper);
          let papers = this.state.data;
          papers.splice(index, 1);
          if (index !== -1) {
            this.setState({
              data: papers,
            });
          } else {
            this.props.showError(
              "Referatul nu a putut fi sters. Incercati din nou",
            );
          }
        })
        .catch((err) => {
          this.props.showError(
            "Referatul nu a putut fi sters. Incercati din nou",
          );
        });
    }
  };

  editFinished = (shouldRefresh) => {
    this.setState({ showEdit: false });
    this.props.onDialogVisible(false);
  };

  onAddModalCancel = () => {
    this.setState({ showAdd: false });
    this.props.onDialogVisible(false);
  };

  addFinished = () => {
    this.setState({ showAdd: false, addData: null });
    this.refreshData(this.state.page);
    this.props.onDialogVisible(false);
  };

  onFileDownloadClick = (paper, isPdf) => {
    let url = Constants.SERVER_ENDPOINT + "/document/docx/" + paper.id;
    if (isPdf) {
      url = Constants.SERVER_ENDPOINT + "/document/pdf/" + paper.id;
    }
    this.showDownloadingProgress(true, paper);
    this.props.hideError();
    request({
      url: url,
      method: "GET",
      responseType: "blob",
    })
      .then((response) => {
        const suggestedFileName = response.headers.filename;
        const effectiveFileName =
          suggestedFileName === undefined
            ? paper.id + ".docx"
            : suggestedFileName;
        fileSaver.saveAs(response.data, effectiveFileName);
        this.showDownloadingProgress(false, paper);
      })
      .catch((response) => {
        console.error(
          "Could not Download the Docx report from the backend.",
          response,
        );
        this.props.showError(
          "Descarcarea documentului a esuat! Va rog reincercati!",
        );
        this.showDownloadingProgress(false, paper);
      });
  };

  onReportDownloadClick = () => {
    let url =
      Constants.SERVER_ENDPOINT +
      "/document/papers/excel?year=" +
      this.state.reportYear;
    this.setState({ downloadingReport: true });
    request({
      url: url,
      method: "GET",
      responseType: "blob",
    })
      .then((response) => {
        const suggestedFileName = response.headers.filename;
        const effectiveFileName =
          suggestedFileName === undefined
            ? "raport referate.xlsx"
            : suggestedFileName;
        fileSaver.saveAs(response.data, effectiveFileName);
        this.setState({ downloadingReport: false });
      })
      .catch((response) => {
        console.error(
          "Could not Download the Docx report from the backend.",
          response,
        );
        this.props.showError(
          "Descarcarea documentului a esuat! Va rog reincercati!",
        );
        this.setState({ downloadingReport: false });
      });
  };

  onDetailedReportDownloadClick = () => {
    let url =
      Constants.SERVER_ENDPOINT +
      "/document/papers-products/excel?year=" +
      this.state.reportYear;
    this.setState({ downloadingReport: true });
    request({
      url: url,
      method: "GET",
      responseType: "blob",
    })
      .then((response) => {
        const suggestedFileName = response.headers.filename;
        const effectiveFileName =
          suggestedFileName === undefined
            ? "raport referate detaliat.xlsx"
            : suggestedFileName;
        fileSaver.saveAs(response.data, effectiveFileName);
        this.setState({ downloadingReport: false });
      })
      .catch((response) => {
        console.error(
          "Could not Download the detailed Excel report from the backend.",
          response,
        );
        this.props.showError(
          "Descarcarea documentului a esuat! Va rog reincercati!",
        );
        this.setState({ downloadingReport: false });
      });
  };

  showDownloadingProgress = (visible, paper) => {
    let index = this.state.data.indexOf(paper);
    if (index !== -1) {
      let newData = this.state.data;
      newData[index].downloadingDoc = visible;
      this.setState({
        downloadingDoc: visible,
        data: newData,
      });
    }
  };

  onApproveFinished = (paper) => {
    if (this.props.removeAfterApproval) {
      let index = this.state.data.indexOf(paper);
      if (index !== -1) {
        let newData = this.state.data;
        newData.splice(index, 1);
        this.setState({
          data: newData,
        });
      }
    } else {
      let index = this.state.data.indexOf(paper);
      if (index !== -1) {
        let newData = this.state.data;
        newData[index] = paper;
        this.setState({
          data: newData,
        });
      }
    }
    this.props.afterPaperApproved();
  };

  handlePageChanged = (newPage) => {
    const newPageInt = parseInt(newPage) - 1;
    this.setState(
      {
        page: newPageInt,
      },
      () => {
        this.refreshData(newPageInt);
      },
    );
    this.props.history.push("/app/referate/" + newPageInt);
  };

  onClickPrint = (paper) => {
    console.log("lucitest here", paper);
    this.setState({
      showPrintDialog: true,
      printPaper: paper,
    });

    this.props.onDialogVisible(true);
  };

  onSetPaperAsPrinted = (paper) => {
    console.log("lucitest paper", paper);

    this.setState({
      data: this.state.data.map((t) => {
        if (t.id === paper.id) {
          return {
            ...t,
            printed: true,
          };
        } else {
          return t;
        }
      }),
    });

    request({
      url: "/paper/setIsPrinted/" + paper.id,
      method: "post",
    })
      .then((t) => {
        console.log("Set as printed", t);
      })
      .catch((err) => {
        this.props.showError(
          "Referatul nu a putut fi finalizat. Incercati din nou",
        );
      });
  };

  render() {
    const paginationButtons = (
      <div>
        <div>
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            maxButtons={10}
            items={this.state.totalPages}
            activePage={this.state.page + 1}
            onSelect={this.handlePageChanged}
          />
        </div>
      </div>
    );

    const searchDiv = (
      <div style={{ display: "inline-block", marginLeft: "12px" }}>
        <div style={{ display: "inline-block", verticalAlign: "middle" }}>
          <DropDownMenu
            value={this.state.searchValue}
            onChange={this.onSearchChanged}
          >
            <MenuItem value={SEARCH_ENGINE} primaryText="MOTOR CAUTARE" />

            <MenuItem
              value={SEARCH_PAPER}
              primaryText="Cauta dupa numar referat"
            />
            <MenuItem
              value={SEARCH_FINANCE_SOURCE}
              primaryText="Cauta dupa sursa de finantare"
            />
            <MenuItem
              value={SEARCH_ACQUISITION_CATEGORY}
              primaryText="Cauta dupa categoria de achizitie"
            />
            <MenuItem
              value={SEARCH_DEPARTMENT}
              primaryText="Cauta dupa compartiment"
            />
            <MenuItem value={SEARCH_BY_DATE} primaryText="Cauta dupa data" />
          </DropDownMenu>
        </div>

        <div style={{ display: "inline-block", verticalAlign: "middle" }}>
          <TextField
            hintText={this.state.searchHintText}
            onChange={(e) => this.setState({ searchWords: e.target.value })}
            value={this.state.searchWords}
            style={{ width: "150px", textAlign: "center" }}
          />
        </div>

        <div
          style={{
            display: "inline-block",
            verticalAlign: "middle",
            marginLeft: "10px",
          }}
        >
          <FlatButton
            primary
            label={"Cauta"}
            onClick={() => {
              if (validator.isEmpty(this.state.searchWords)) {
                return;
              }
              this.refreshData(this.state.page);
              this.setState({
                filterValue: FILTER_ALL,
              });
            }}
          />
        </div>
      </div>
    );

    const filterDiv = (
      <div style={{ textAlign: "center" }}>
        <div style={{ display: "inline-block", verticalAlign: "middle" }}>
          {!this.props.needApprovalPage && (
            <DropDownMenu
              value={this.state.filterValue}
              onChange={this.onFilterChanged}
            >
              <MenuItem value={FILTER_ALL} primaryText="Filtreaza toate" />
              <MenuItem
                value={FILTER_APROVED}
                primaryText="Filtreaza aprobate"
              />
              <MenuItem
                value={FILTER_IN_PROGRESS}
                primaryText="Filtreaza in curs de aprobare"
              />
              <MenuItem
                value={FILTER_REJECTED}
                primaryText="Filtreaza respinse"
              />
              {this.props.isInApprovalFlow && this.props.userDepartment && (
                <MenuItem
                  value={FILTER_BY_ME}
                  primaryText="Filtreaza create de mine"
                />
              )}
              {!this.props.isInApprovalFlow && (
                <MenuItem
                  value={FILTER_DRAFT}
                  primaryText="Filtreaza drafturi"
                />
              )}
            </DropDownMenu>
          )}
        </div>
        {(this.props.isInApprovalFlow || this.props.canSeeAllPapers) &&
          searchDiv}
      </div>
    );

    const downloadPaperReport = (
      <HorizontalContainer style={{ alignItems: "center", marginLeft: 12 }}>
        <TextField
          style={{ marginLeft: 24, width: 60 }}
          floatingLabelText="Anul"
          type={"number"}
          value={this.state.reportYear}
          onChange={(e) => {
            this.setState({ reportYear: e.target.value });
          }}
        />

        <FlatButton
          style={{
            marginRight: "20px",
            display: "inline-block",
            verticalAlign: "middle",
          }}
          primary
          label={"Descarca excel"}
          onClick={() => this.onReportDownloadClick()}
        />

        <FlatButton
          style={{
            marginRight: "20px",
            display: "inline-block",
            verticalAlign: "middle",
          }}
          primary
          label={"Descarca excel detaliat"}
          onClick={() => this.onDetailedReportDownloadClick()}
        />

        {this.state.downloadingReport && <CircularProgress />}
      </HorizontalContainer>
    );

    return (
      <div>
        <RedirectIfNotLogged />

        {this.state.showAdd === true ? (
          <PurchaseRequisitionAddModal
            title={"Adauga referat"}
            onCancel={this.onAddModalCancel}
            addFinished={this.addFinished}
            data={this.state.addData}
            forNextYear={this.state.forNextYear}
          />
        ) : (
          ""
        )}

        {this.state.showEdit ? (
          <PurchaseRequisitionEditModal
            title={
              "Editeaza referat: " +
              this.state.editData.yearId +
              "/" +
              this.state.editData.createdYear
            }
            onCancel={this.editFinished}
            data={this.state.editData}
            canDownload={true}
            canEditPapers={this.state.canEditPapers}
            canSetArticolBugetar={this.state.canSetArticolBugetar}
            downloadingDoc={this.state.downloadingDoc}
            onApproveFinished={this.onApproveFinished}
            onFileDownloadClick={this.onFileDownloadClick}
            onClickPrint={this.onClickPrint}
          />
        ) : (
          ""
        )}

        <div style={{ display: "flex" }}>
          <Header title={this.props.title} />
          <div style={{ marginTop: 8 }}>
            {!this.props.needApprovalPage &&
              !this.state.loadingData &&
              filterDiv}
          </div>
        </div>
        <div>
          {this.state.emptyData && (
            <div>
              <div style={{ textAlign: "center", marginTop: "50px" }}>
                <h3>{this.props.emptyDataText}</h3>
              </div>
            </div>
          )}

          {!this.state.loadingData && (
            <div style={{ width: "100%" }}>
              {this.props.userDepartment && !this.props.needApprovalPage && (
                <div style={{ float: "right" }}>
                  <TopActionsComponent onAddClicked={this.onAddClicked} />
                </div>
              )}

              <HorizontalContainer>
                {this.props.canSeePapersExcelReport && downloadPaperReport}
              </HorizontalContainer>
            </div>
          )}

          {this.state.showPrintDialog && this.state.printPaper && (
            <PrintDialog
              paper={this.state.printPaper}
              onClose={() => {
                this.setState({
                  showPrintDialog: false,
                });

                this.props.onDialogVisible(true);
              }}
            />
          )}

          {this.state.loadingData ? (
            <div style={{ textAlign: "center" }}>
              <CircularProgress />
            </div>
          ) : (
            !this.state.emptyData && (
              <div>
                <div style={{ display: "inline-block" }}>
                  <div>
                    <TablePaper
                      data={this.state.data}
                      canEdit={true}
                      onDeleteClicked={this.onDeleteClicked}
                      onEditClicked={this.onEditClicked}
                      onFileDownloadClick={this.onFileDownloadClick}
                      onClickPrint={this.onClickPrint}
                      canSetPaperAsPrinted={this.props.canSetPaperAsPrinted}
                      onSetPaperAsPrinted={this.onSetPaperAsPrinted}
                    />
                    {!this.props.needApprovalPage &&
                      this.state.totalPages > 0 &&
                      paginationButtons}
                  </div>
                </div>
              </div>
            )
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    userDepartment: state.login.user.department,
    isInApprovalFlow: state.login.user.isInApprovalFlow,
    canSeePapersExcelReport: state.login.user.canSeePapersExcelReport,
    canSeeApprovedPapers: state.login.user.canSeeApprovedPapers,
    canSeeAllPapers: state.login.user.canSeeAllPapers,
    canSetPaperAsPrinted: state.login.user.canSetPaperAsPrinted,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showError: (text) => dispatch(ErrorAction.showError(text)),
    hideError: () => dispatch(ErrorAction.hideError()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PaperPage);
